import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import axios from 'axios';
import moment from 'moment';
const VueLoadImage = require('vue-load-image').default;

@Component({
  props: {},
  components: {
    'vue-load-image': VueLoadImage,
  },
})

export default class BetterNewsCoZaHome extends Vue {
  private wpData: any[] | null = null;
  private wpDataFeatured: any[] | null = null;
  private wpDataPage: number = 1;
  private wpDataPerPage: number = 3;
  private wpDataPageTotal: number = 0;
  private tags: any[] = [];
  private tagsActive: number = 0;
  private categories: any[] = [];
  private categoriesActive: number = 0;
  private authors: any[] = [];
  private authorsActive: number = 0;
  private searchTextModel: string = '';
  private searchText: string = '';
  private wpDataSelectedPost: any | null = null;

  @Watch('$route')
  onRouteChange(value: string, oldValue: string) {
    this.routeSet();
  }

  private async routeSet() {
    this.$data.wpDataPage = 1;
    if (this.$route.params.seeType === 'Post') {
      let postInSesh = null;

      if (this.wpData !== null) {
        for (let post of this.wpData as any[]) {
          if (post.id === this.$route.params.id) {
            postInSesh = post;
            break;
          }
        }
      }

      if (postInSesh === null) {
        postInSesh = await this.getPost(this.$route.params.id);
      }

      this.$data.wpDataSelectedPost = postInSesh;
    } else if (['Categories', 'Tags', 'Author'].indexOf(this.$route.params.seeType) >= 0) {
      this.getPosts(1);
    } else {
      this.getPosts(this.wpDataPage);
    }
  }

  private searchPosts(text?: string): void {
    if (text !== undefined) {
      this.$data.searchText = text;
    }
    this.$data.searchTextModel = this.searchText;
    if (this.searchText === '') {
      this.getPosts(1);
      return;
    }
    this.getPosts(1, this.searchText);
  }

  private getNiceFormattedDate(dateObj: string): string {
    return moment(dateObj).format('DD/MM/YYYY');
  }
  private getImage(urlOfMedia: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axios({
        url: urlOfMedia,
        method: 'GET',
      }).then((x: any) => {
        resolve(x.data);
      }).catch(reject);
    });
  }
  private getTotalForType(seeType: string, id: number): Promise<number> {
    return new Promise((resolve, reject) => {
      axios({
        url: `https://crm.news.bettercorp.co.za/wp-json/wp/v2/posts?page=1&per_page=1&status=publish${seeType === 'Author'
          ? `&author=${id}` : ''}${
          seeType === 'Categories'
            ? `&categories=${id}` : ''}${
          seeType === 'Tags'
            ? `&tags=${id}` : ''}`,
        method: 'GET',
      }).then(async (x: any) => {
        resolve(Number.parseInt(x.headers['x-wp-totalpages']));
      }).catch(reject)
    })
  }
  private getPosts(page: number, searchString?: string) {
    this.$data.wpDataPage = page;
    if (this.wpData !== null) {
      window.scrollTo(0, (window as any).document.getElementById('blogPosts').offsetTop - 100);
    }
    this.$data.wpData = null;
    axios({
      url: `https://crm.news.bettercorp.co.za/wp-json/wp/v2/posts?page=${this.wpDataPage
        }&per_page=${this.wpDataPerPage}&status=publish${searchString ? `&search=${searchString}` : ''
        }${this.$route.params.seeType === 'Author'
          ? `&author=${this.$route.params.id}` : ''}${
        this.$route.params.seeType === 'Categories'
          ? `&categories=${this.$route.params.id}` : ''}${
        this.$route.params.seeType === 'Tags'
          ? `&tags=${this.$route.params.id}` : ''}`,
      method: 'GET',
    }).then(async (x: any) => {
      this.$data.wpDataPageTotal = Number.parseInt(x.headers['x-wp-totalpages']);
      let newData = x.data;
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < newData.length; index++) {
        newData[index] = await this.getPost(newData[index].id, newData[index]);
      }
      this.$data.wpData = newData;
    }).catch(console.error);
  }
  private async mounted() {
    this.$data.tags = (await axios({
      url: 'https://crm.news.bettercorp.co.za/wp-json/wp/v2/tags',
      method: 'GET',
    })).data;
    this.$data.categories = (await axios({
      url: 'https://crm.news.bettercorp.co.za/wp-json/wp/v2/categories',
      method: 'GET',
    })).data;
    this.$data.authors = (await axios({
      url: 'https://crm.news.bettercorp.co.za/wp-json/wp/v2/users',
      method: 'GET',
    })).data;
    this.$nextTick(async () => {
      this.$data.tagsActive = 0;
      for (let i = 0; i < this.tags.length; i++) {
        this.$data.tags[i]._posts = await this.getTotalForType('Tags', this.tags[i].id);
        if (this.$data.tags[i]._posts > 0) {
          this.$data.tagsActive++;
        }
      }
      this.$data.categoriesActive = 0;
      for (let i = 0; i < this.categories.length; i++) {
        this.$data.categories[i]._posts = await this.getTotalForType('Categories', this.categories[i].id);
        if (this.$data.categories[i]._posts > 0) {
          this.$data.categoriesActive++;
        }
      }
      this.$data.authorsActive = 0;
      for (let i = 0; i < this.authors.length; i++) {
        this.$data.authors[i]._posts = await this.getTotalForType('Authors', this.categories[i].id);
        if (this.$data.authors[i]._posts > 0) {
          this.$data.authorsActive++;
        }
      }
      // for (let i = 0 ; i < this.authors.length ; i++) {
      //   this.$data.authors[i]._posts = await this.getTotalForType('Author', this.authors[i].id);
      // }
    });
    this.getPosts(1);
    axios({
      url: `https://crm.news.bettercorp.co.za/wp-json/wp/v2/posts?sticky=1&per_page=${5}&page=1`,
      method: 'GET',
    }).then(async (x: any) => {
      let newData = x.data;
      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < newData.length; index++) {
        newData[index]._featureImage = await this.getImage(newData[index]._links['wp:featuredmedia'][0].href);
        let newCategories: any[] = [];
        for (let innerIndex = 0; innerIndex < newData[index].categories; innerIndex++) {
          for (let category of this.categories) {
            if (category.id === newData[index].categories[innerIndex]) {
              newCategories.push(category);
              break;
            }
          }
        }
        newData[index]._categories = newCategories;
        let newTags: any[] = [];
        for (let innerIndex = 0; innerIndex < newData[index].tags; innerIndex++) {
          for (let tag of this.tags) {
            if (tag.id === newData[index].tags[innerIndex]) {
              newTags.push(tag);
              break;
            }
          }
        }
        newData[index]._tags = newTags;
        let newUser: any = null;
        for (let author of this.authors) {
          if (author.id === newData[index].author) {
            newUser = author;
            break;
          }
        }
        newData[index]._author = newUser;
      }
      this.$data.wpDataFeatured = newData;
      this.routeSet();
    }).catch(console.error);
  }
  private getPost(id: string, postData?: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (postData === undefined) {
        axios({
          url: `https://crm.news.bettercorp.co.za/wp-json/wp/v2/posts/?filter[p]=${id}`,
          method: 'GET',
        }).then(async (x: any) => {
          let selPost = null;
          if (Array.isArray(x.data)) {
            for (let item of x.data) {
              if (item.id == id) {
                selPost = item;
                break;
              }
            }
          } else {
            selPost = x.data;
          }
          if (selPost === null) {
            return reject();
          }
          this.getPost(selPost.id, selPost).then(resolve).catch(reject);
        }).catch(reject);
      } else {
        postData._featureImage = await this.getImage(postData._links['wp:featuredmedia'][0].href);
        let newCategories: any[] = [];
        for (let innerIndex = 0; innerIndex < postData.categories; innerIndex++) {
          for (let category of this.categories) {
            if (category.id === postData.categories[innerIndex]) {
              newCategories.push(category);
              break;
            }
          }
        }
        postData._categories = newCategories;
        let newTags: any[] = [];
        for (let innerIndex = 0; innerIndex < postData.tags; innerIndex++) {
          for (let tag of this.tags) {
            if (tag.id === postData.tags[innerIndex]) {
              newTags.push(tag);
              break;
            }
          }
        }
        postData._tags = newTags;
        let newUser: any = null;
        for (let author of this.authors) {
          if (author.id === postData.author) {
            newUser = author;
            break;
          }
        }
        postData._author = newUser;
        resolve(postData);
      }
    });
  }
}
